import * as Yup from "yup"

const fieldValidationSchema = Yup.object().shape({
  description: Yup.string(),
  field_description: Yup.string(),
  field_label: Yup.string(),
  field_option: Yup.string(),
  field_type_subtype: Yup.string().when("field_type", {
    is: "date",
    then: (schema) => schema.required("Field subtype is required"),
    otherwise: (schema) => schema,
  }),
  field_number_min: Yup.number().typeError("Must be a number"),
  field_number_max: Yup.number()
    .typeError("Must be a number")
    .test(
      "is-greater-than-min",
      "Maximum number must be greater than minimum number",
      function (value) {
        const { field_number_min } = this.parent
        return !field_number_min || !value || value > field_number_min
      }
    )
    .test("not-zero", "Maximum number cannot be 0", function (value) {
      return value !== 0
    }),
})

export default fieldValidationSchema
